import _get from 'lodash/get';
import { getFormattedType } from 'components/ResourceItemSelector/utils';
export default function(data) {
  const type = _get(data, '__typename');
  const isBlog = _get(data, 'blog', false);
  return isBlog ? 'blog' : getFormattedType(type.toLowerCase());
}
